/*
 * Cadwork webgl Engine
 * http://www.lexoview.com
 *
 * Copyright (C) 2015 Cadwork Informatik AG, Basel, Switzerland
 * Dual licensed under the MIT and GPL
 *
 * @author Jaroslav Přibyl (pribyl@cadwork.cz)
 *
 */

import TextureDataHandler from "App/utils/textures/texture_data_handler";
import ImageDataLoader from "App/utils/textures/image_data_loader";
import {EDataTypeType} from "App/geometry/material/texture";
import ImageDataLoadersFactory from "App/utils/textures/image_data_loaders_factory";

export default
class DOMImageDataLoader extends ImageDataLoader {
    public static TypeName: string = EDataTypeType.imageTexture;

    constructor(aTextureDataHandler: TextureDataHandler, aDiffuseTextureProperties: any, aLevel: number) {
        super(aTextureDataHandler, aDiffuseTextureProperties, aLevel);
    }

    public static create(aTextureDataHandler: TextureDataHandler, aDiffuseTextureProperties: any, aLevel: number): DOMImageDataLoader {
        return new DOMImageDataLoader(aTextureDataHandler, aDiffuseTextureProperties, aLevel);
    }

    public getNeedMipmapsGeneration() {
        return true;
    }

    public prepareData() {
        if (this._loadIterator >= this.tiles.length) {
            return;
        }

        let domImageObject = new Image();

        let self = this;
        domImageObject.onload = (function (aLoadIterator) {
            return function () {
                let tile = self.tiles[aLoadIterator];
                tile.width = domImageObject.width;
                tile.height = domImageObject.height;
                tile.data = domImageObject;
                tile.ready = true;

                // here we test if we specify the texture using only the url wihtout knowing the size of it
                // it this case we re-init the properties based on th reloaded dom image object
                if (!self._diffuseTextureProperties.tiled &&
                    self._diffuseTextureProperties.width === 0 &&
                    self._diffuseTextureProperties.height === 0) {
                    self._diffuseTextureProperties.width = domImageObject.width;
                    self._diffuseTextureProperties.height = domImageObject.height;
                }

                // @ts-ignore
                let urlCreator = window.URL || webkitURL;
                urlCreator.revokeObjectURL(domImageObject.src);
            };
        })(this._loadIterator);

        domImageObject.onerror = (function (aLoadIterator) {
            return function () {
                let tile = self.tiles[aLoadIterator];
                tile.width = 0;
                tile.height = 0;
                tile.ready = true;
            };
        })(this._loadIterator);

        let tile = this.tiles[this._loadIterator];

        let ext = '';
        let indexOfLastDot = this._diffuseTextureProperties.url.lastIndexOf('.');
        if (indexOfLastDot !== -1) {
            if (this._diffuseTextureProperties.url.substr(indexOfLastDot + 1) === "svg") { // hack for svg
                ext = '/svg+xml';
            }
        }
        let arrayBufferView = new Uint8Array(tile.compressedUint8Data);
        let blob = new Blob([arrayBufferView.buffer], {type: 'image' + ext});
        let urlCreator = window.URL || webkitURL;
        let imageUrl = urlCreator.createObjectURL(blob);
        domImageObject.src = imageUrl;

        this._loadIterator++;
    };
}

ImageDataLoadersFactory.register(DOMImageDataLoader);